<template>
  <div class="inclusion-exclusion">
    <div class="info-panel">
      <div class="info-title">
        纳入条件
      </div>
      <template v-if="!edit">
        <div class="info-item" v-for="(item, index) in datasource1" :key="index">
          {{ `${item.sortNum}、${item.description}` }}
          <!-- <span class="info-item-center" v-if="item.centerName">{{ `${item.centerName}` }}</span> -->
        </div>
      </template>
      <a-table rowKey="id" v-else size="small" :columns="columns" :dataSource="datasource1" :pagination="false"
        :loading="loading">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <div class="info-panel">
      <div class="info-title">
        排除条件
      </div>
      <template v-if="!edit">
        <div class="info-item" v-for="(item, index) in datasource2" :key="index">
          {{ `${item.sortNum}、${item.description}` }}
        </div>
      </template>
      <a-table rowKey="id" v-else size="small" :columns="columns" :dataSource="datasource2" :pagination="false"
        :loading="loading">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <div class="info-panel">
      <div class="info-title">
        终止随访
      </div>
      <template v-if="!edit">
        <div class="info-item" v-for="(item, index) in datasource3" :key="index">
          {{ `${item.sortNum}、${item.description}` }}
        </div>
      </template>
      <a-table rowKey="id" v-else size="small" :columns="columns" :dataSource="datasource3" :pagination="false"
        :loading="loading">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <template v-if="isEdit">
      <a-button type="primary" v-if="!edit" @click="edit = true">编辑</a-button>
      <a-button type="primary" v-if="edit" @click="handleAdd">添加</a-button>
      <a-button v-if="edit" @click="edit = false" style="margin-left: 20px">完成</a-button>
    </template>
    <a-modal v-if="isEdit" title="编辑" rowKey="id" :width="1000" :visible="formVisible" :confirmLoading="confirmLoading"
      @ok="handleSubmit" @cancel="handleCancel">
      <a-form-model :model="model" layout="horizontal" style="padding-left: 20px;padding-right: 20px;" v-bind="{
        labelCol: { span: 4 },
        wrapperCol: { span: 16 },
      }" :rules="rules">
        <a-form-model-item label="分组名称" props="type">
          <a-radio-group v-model="model.type">
            <a-radio value="1">纳入条件</a-radio>
            <a-radio value="2">排除条件</a-radio>
            <a-radio value="3">终止随访</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="内容" props="description">
          <a-textarea :rows="2" v-model="model.description" />
        </a-form-model-item>
        <a-form-model-item label="排序" props="sortNum">
          <a-input-number v-model="model.sortNum" :min="0" :precision="0" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="备注弹框" props="description">
          <a-switch checkedChildren="开启" unCheckedChildren="关闭" v-model="remarkFlag" @change="onSwitchChange" />
        </a-form-model-item>
        <a-form-model-item label="所属中心">
          <a-select placeholder="请选择研究中心" v-model="model.centerId" style="width: 200px" allow-clear>
              <a-select-option v-for="(item,index) in centerList" :key="index" :value="item.centerId">
                {{ item.center.name }}
              </a-select-option>
            </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { getAction, postAction, deleteAction } from '@/api/manage'
import baseRules from '@/constants/baseRules'
import Vue from 'vue'
export default {
  name: 'Filtrate',
  components: {},
  props: {
    projectId: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    url: {
      type: Object,
      default: () => {
        return {
          listUrl: '/project/projectFiltrate/listByCenter',
          deleteUrl: '/project/projectFiltrate/delete',
          saveUrl: '/project/projectFiltrate/saveOrUpdate',
        }
      }
    },
  },
  data() {
    return {
      datasource: [],
      formVisible: false,
      confirmLoading: false,
      edit: false,
      loading: false,
      model: {},
      remarkFlag:'false',
      rules: {
        type: [baseRules.required],
        description: [baseRules.required],
        sortNum: [baseRules.required],
      },
      columns: [
        {
          title: '排序',
          align: 'center',
          width: 100,
          dataIndex: 'sortNum'
        },
        {
          title: '内容',
          align: 'left',
          ellipsis: true,
          dataIndex: 'description'
        },
        {
          title: '所属中心',
          align: 'center',
          width: 150,
          dataIndex: 'centerName'
        },

        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'action' },
        }
      ],
      centerList: [],
    }
  },
  watch: {
    projectId() {
      this.loadData()
    }
  },
  computed: {
    datasource1() {
      return this.datasource.filter(item => item.type === '1')
    },
    datasource2() {
      return this.datasource.filter(item => item.type === '2')
    },
    datasource3() {
      return this.datasource.filter(item => item.type === '3')
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.projectId) {
        return
      }
      const projectId = this.projectId
      this.loading = true
      getAction(this.url.listUrl, { projectId: projectId }).then(res => {
        if (res.success) {
          this.datasource = res.result
        }
      }).finally(() => {
        this.loading = false
      })
      this.loadCenter()
    },
    handleAdd() {
      this.handleEdit({ projectId: this.projectId, type: '1', sortNum: 1 })
    },
    handleEdit(record) {
      if (!this.projectId) {
        return this.$message.error('非法参数')
      }
      this.model = Object.assign({}, record)
      this.remarkFlag= this.model.remarkFlag==='1'?true:false
      this.formVisible = true
    },
    handleDelete(id) {
      deleteAction(this.url.deleteUrl, { id: id }).then(res => {
        if (res.success) {
          this.loadData()
        }
      })
    },
    handleCancel() {
      this.model = {}
      this.formVisible = false
    },
    handleSubmit() {
      this.confirmLoading = true
      this.model.remarkFlag = this.remarkFlag ? '1' : '0'
      postAction(this.url.saveUrl, this.model).then(res => {
        if (res.success) {
          this.loadData()
          this.handleCancel()
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    onSwitchChange() {
      this.model.remarkFlag = this.remarkFlag ? '1' : '0'
    },
    loadCenter(){
      getAction('/project/center/listAll', { projectId: this.projectId }).then(res => {
        if (res.success) {
          this.centerList = res.result
        }
      })
    }
  }

}
</script>

<style scoped lang="less">
.inclusion-exclusion {
  .info-panel {
    margin-bottom: 10px;

    .info-title {
      font-size: 16px;
    }

    .info-item {
      margin-left: 20px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      line-height: 28px;
    }
  }
}
</style>